import axios from "axios";
import { getApiBase } from "../apiBase";
import {
  emitMarketplaceClawbackFromResponse,
  emitMarketplaceRewardFromResponse,
} from "./marketplaceRewards";

/**
 * Upload a file into `projects.acf_groups_json` at `fieldPath` (e.g. ["Engineering Test 2","permit_files"]).
 * Replaces the field value with a public API URL; removes prior project_field_files row if URL pointed here.
 */
export async function uploadProjectFieldFile(projectId, fieldPath, file, getAuthHeaders) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("fieldPath", JSON.stringify(fieldPath));
  const { data } = await axios.post(`${getApiBase()}/projects/${projectId}/field-files`, fd, {
    headers: getAuthHeaders(),
  });
  emitMarketplaceRewardFromResponse(data);
  return data;
}

/** Append a file as `{ site_walk_file: url }` to the `site_walk_files` array (fieldPath = [groupKey, "site_walk_files"]). */
export async function uploadProjectFieldFileAppend(projectId, fieldPath, file, getAuthHeaders) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("fieldPath", JSON.stringify(fieldPath));
  fd.append("append", "true");
  const { data } = await axios.post(`${getApiBase()}/projects/${projectId}/field-files`, fd, {
    headers: getAuthHeaders(),
  });
  emitMarketplaceRewardFromResponse(data);
  return data;
}

export async function clearProjectFieldFile(projectId, fieldPath, getAuthHeaders) {
  const { data } = await axios.delete(`${getApiBase()}/projects/${projectId}/field-files`, {
    headers: getAuthHeaders(),
    data: { fieldPath },
  });
  emitMarketplaceClawbackFromResponse(data);
  return data;
}

/** Download a public URL server-side and attach to a project file field (replaces on re-import by default). */
export async function importProjectFieldFileFromUrl(
  projectId,
  fieldPath,
  url,
  getAuthHeaders,
  { append = false, replace = true } = {}
) {
  const { data } = await axios.post(
    `${getApiBase()}/projects/${projectId}/field-files/import-url`,
    { url, fieldPath, append, replace },
    {
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
    }
  );
  emitMarketplaceRewardFromResponse(data);
  return data;
}
